import * as React from 'react';
import {useEffect, useState} from "react";
import FileService from "../../services/FileService";
import useDrive from "../../hooks/useDrive";

export function FileThumbnail({row, width}) {
    const [thumb, setThumb] = useState()
    const {CurrentDrive} = useDrive();

    useEffect(() => {
        setThumb(row.iconSrc)
        if (row && row.type === 'file' && row.path) {
            if(row.Key.match(/\.(jpg|jpeg|png|gif)$/i)) {
                getViewLink(row.path);
            }
        }
    }, [row]);

    const getViewLink = async path => {
        const res = await FileService.getDownLoadLink('', path, CurrentDrive.driveType);
        setThumb(res.hasOwnProperty('thumbnail') ? 'data:image/png;base64,' + res.thumbnail : res);
        // console.log("dow", res);
    }
    return (
        <img src={thumb} width={width}  alt={"thumbnail"}/>
    );
}